import React, { useState, useRef, useEffect } from 'react';
import {
  PencilSquareIcon,
} from '@heroicons/react/24/solid';
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';

const ReportsActionsMenu = ({ report, onEdit, onSaveReport, onCancelReport }) => {

  const [open, setOpen] = useState(false);
  const [selectedReport, setSelectedReport] = useState(report || {});
  const [editMode, setEditMode] = useState(false);
  const menuRef = useRef();

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleEdit = () => {
    setEditMode(true);
    onEdit(selectedReport);
  };

  const handleConfirm = () => {
    const success = onSaveReport(selectedReport);
    if (success) {
      setEditMode(false);
    }
  };

  const handleCancel = () => {
    const report = onCancelReport(selectedReport);
    setSelectedReport(report);
    setEditMode(false);
  };

  return (
    <>
      {/* ✅ Desktop view: Edit + 3-dot dropdown */}
      <div className="hidden md:flex items-center gap-2 relative" ref={menuRef}>
        {!editMode ? (
          <button
            onClick={handleEdit}
            className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100"
            title="Edit"
          >
            <PencilSquareIcon className="h-5 w-5 text-blue-600" />
          </button>
        ) : (
          <>
            <button
              onClick={handleConfirm}
              className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-green-100"
              title="Confirm"
            >
              <CheckIcon className="h-5 w-5 text-green-600" />
            </button>

            <button
              onClick={handleCancel}
              className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-red-100"
              title="Cancel"
            >
              <XMarkIcon className="h-5 w-5 text-red-600" />
            </button>
          </>
        )}
      </div>

      
      {/* ✅ Mobile View: Show all actions in 2 columns with different colors */}
      <div className="md:hidden flex flex-col gap-2 mt-2">
          <button
            onClick={handleEdit}
            className="flex items-center text-blue-600"
          >
            <PencilSquareIcon className="w-4 h-4 mr-1" />
            Edit
          </button>
      </div>
    </>
  );
};

export default ReportsActionsMenu;
